import type { LoginButtonProps } from "./login-button.type";

import { useQueryClient } from "@tanstack/react-query";
import { Button } from "antd";
import { signInWithRedirect } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const LoginButton = (buttonProps: LoginButtonProps) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    // Clear remove all queries when user visits the login page
    queryClient.removeQueries();
  }, []);

  const login = () => {
    setIsLoading(true);
    signInWithRedirect();
  };

  return (
    <Button
      {...buttonProps}
      onClick={login}
      loading={isLoading}
      disabled={isLoading}
      className="login-button"
    >
      {t("auth:login")}
    </Button>
  );
};

export default LoginButton;
